'use client';

import React, { useState, useEffect, useCallback } from 'react';
import Navigation from '@/components/ui/Navigation';
import Hero from '@/components/sections/Hero';
import About from '@/components/sections/About';
import Skills from '@/components/sections/Skills';
import Projects from '@/components/sections/Projects';
import Services from '@/components/sections/Services';
import Testimonials from '@/components/sections/Testimonials';
import Contact from '@/components/sections/Contact';
import Footer from '@/components/sections/Footer';

const SECTIONS = ['hero', 'about', 'skills', 'projects', 'services', 'testimonials', 'contact'];

export default function Home() {
  const [activeSection, setActiveSection] = useState('hero');

  const handleScroll = useCallback(() => {
    const scrollY = window.scrollY + window.innerHeight / 3;

    for (let i = SECTIONS?.length - 1; i >= 0; i--) {
      const el = document.getElementById(SECTIONS?.[i]);
      if (el && el?.offsetTop <= scrollY) {
        setActiveSection(SECTIONS?.[i]);
        break;
      }
    }
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  return (
    <main className="relative">
      <Navigation activeSection={activeSection} />
      <Hero />
      <About />
      <Skills />
      <Projects />
      <Services />
      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
}
